$(document).ready(function () {
    $('.withdrawals').on("click", '.show_withdraw_decline_modal', function (event) {
        event.preventDefault();

        let withdrawal_id = $(this).data('withdrawal-id');
        let modal = $('#withdraw_decline_modal');

        modal.find('.modal-body :input').val('');
        $('input[name=withdrawal_id]').val(withdrawal_id);

        modal.modal('show');
    })
});